// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-contextmenu[data-v-2a4dc6e5]{-webkit-transform-origin:center top;transform-origin:center top;z-index:2190;position:fixed}.custom-contextmenu .el-dropdown-menu__item[data-v-2a4dc6e5]{font-size:12px !important;white-space:nowrap}.custom-contextmenu .el-dropdown-menu__item i[data-v-2a4dc6e5]{font-size:12px !important}", ""]);
// Exports
module.exports = exports;
